<template>
    <div>
        <md-dialog :md-active.sync="showPresetEditor" @md-closed="closePresetEditor">
            <md-dialog-title>
                {{presetData.abnormality == "" ? "N" : "Abn"}}ormal Panel Preset Editor
            </md-dialog-title>
            <md-dialog-content>
                <div v-if="presetData.panel">
                    <md-field id="case-title-input">
                        <md-input 
                            v-model="presetData.abnormality"
                            @change="savePresetData()"
                            maxlength="100"
                            placeholder="Panel abnormality/descriptor (leave blank if normal result)"
                        />
                    </md-field>
                    <center>
                        <md-switch v-model="presetData.public" class="md-primary"
                        @change="savePresetData()">
                            <b>Share Preset w/ Community</b>
                        </md-switch>
                        <br>
                        <md-button :href="'/panel_presets/' + presetID" target="_blank"
                        v-if="presetData.public" class="md-dense md-primary">
                            Preview
                        </md-button>
                    </center>
                    <hr>
                    <div style="position: relative;">
                        <md-speed-dial class="md-top-right" md-direction="bottom" md-event="click" style="top: 0px; right: -14px;">
                            <div>
                                <md-speed-dial-target class="md-primary md-mini">
                                    <md-icon class="md-morph-initial">settings</md-icon>
                                    <md-icon class="md-morph-final">close</md-icon>
                                </md-speed-dial-target>
                                <md-tooltip md-direction="left">
                                    Preset Options
                                </md-tooltip>
                            </div>
                            <md-speed-dial-content>
                                <div>
                                    <md-button class="md-icon-button md-raised"  @click="duplicatePreset">
                                        <md-icon>file_copy</md-icon>
                                    </md-button>
                                    <md-tooltip md-direction="left">
                                        Duplicate Preset
                                    </md-tooltip>
                                </div>
                                <div>
                                    <md-button class="md-accent md-icon-button"  @click="deletePreset">
                                        <md-icon>delete_forever</md-icon>
                                    </md-button>
                                    <md-tooltip md-direction="left">
                                        Delete Preset
                                    </md-tooltip>
                                </div>
                            </md-speed-dial-content>
                        </md-speed-dial>
                        <PanelEditor :activePanel.sync="presetData.panel" :costData="costData" presetMode/>
                    </div>
                </div>
                <center v-else>
                    <md-progress-spinner :md-diameter="60" :md-stroke="10" md-mode="indeterminate">
                    </md-progress-spinner>
                </center>
            </md-dialog-content>
			<md-dialog-actions>
                <md-button class="md-raised" @click="showPresetEditor=false;">Close</md-button>
				<md-button class="md-primary md-raised" @click="savePresetData()">Save</md-button>
			</md-dialog-actions>
        </md-dialog>
        <!-- Notification Snackbar -->
		<md-snackbar md-position="left" :md-duration="notificationDuration" :md-active.sync="showNotification">
			<span>{{notificationContents}}</span>
			<md-button class="md-primary" @click="showNotification=false">X</md-button>
		</md-snackbar>
    </div>
</template>

<script>
    import APIRequests from "../APIRequests.js"
    import PanelEditor from "./PanelEditor.vue"

    export default {
        data: function () {
            return {
                showPresetEditor: this.$route.query.presetID && this.$route.query.presetID.trim().length > 1,
                presetID: "",
                presetData: {},
                costData: {},
                showNotification: false,
                notificationDuration: 2500,
				notificationContents: "",
            }
        },
        watch: {
            "$route": function(){
                this.presetID = this.$route.query.presetID
                this.loadPresetData()
                if(this.presetID) this.showPresetEditor = true
            }
        },
        components: {
            PanelEditor,
        },
        methods: {
            closePresetEditor: function(){
                this.presetID = ""
                this.$router.push("/settings/panel_presets")
                this.showPresetEditor = false
                this.presetData = {}
            },
            loadPresetData: function () {
                this.presetID = this.$route.query.presetID
                if(!this.presetID) return
                let api_url = this.$store.state.api_url + "/api/panelPresets/" + this.presetID
                APIRequests.getJSONData(api_url, this.$store.state.jwtToken).then((data) => {
                    if (!data) data = {}
                    if(data.pid != this.$store.state.jwtClaims.pid) {
                        this.notify("You do not have permission to edit this preset!")
                        this.closePresetEditor()
                        return
                    }
                    this.presetData = data
                }).catch(() => {
                    this.notify("Could not load preset data.")
                    this.closePresetEditor()
                })
            },
            fetchCostData: function () {
                APIRequests.getJSONData(
                    this.$store.state.api_url + "/partB_costs.json",
                    this.$store.state.jwtToken
                ).then((response) => {
                    this.costData = response
                }).catch(() => {
                    this.notify("Could not load test cost data! Please refresh and try again...")
                })
            },
            savePresetData: function() {
                let updatedPreset = this.presetData
                updatedPreset.panel.cost = parseFloat(updatedPreset.panel.cost)
                let api_url = this.$store.state.api_url + "/api/panelPresets/update"
                APIRequests.postJSONData(api_url, this.presetData, this.$store.state.jwtToken).then((data) => {
                    if (!data) data = {}
                    this.notify("Successfully updated panel preset!")
                    this.$emit("fetchPanelPresets")
                })
            },
            deletePreset: function() {
                let confirm_msg = "Are you sure you want to delete this panel preset?"
                if(!confirm(confirm_msg)) return
                let api_url = this.$store.state.api_url + "/api/panelPresets/" + this.presetID + "/delete"
                APIRequests.getJSONData(api_url, this.$store.state.jwtToken).then(() => {
                    this.$emit("fetchPanelPresets")
                    this.closePresetEditor()
                }).catch(() => {
                    this.$emit("notify", "Failed to duplicate panel preset.")
                })
            },
            duplicatePreset: function(){
                let confirm_msg = "Are you sure you want to duplicate this panel preset?"
                if(!confirm(confirm_msg)) return
                let api_url = this.$store.state.api_url + "/api/panelPresets/" + this.presetID + "/duplicate"
                APIRequests.getJSONData(api_url, this.$store.state.jwtToken).then((data) => {
                    if(!data) data = {}
                    if(!data.presetID) throw "Missing preset ID in response from server"
                    alert("Preset duplicated sucessfully. If a new tab does not appear with the newly duplicated preset, please disable your popup blocker for this website.")
                    var win = window.open("/settings/panel_presets?presetID=" + data.presetID, '_blank');
                    win.focus();
                    this.$emit("fetchPanelPresets")
                    this.closePresetEditor()
                }).catch(() => {
                    this.$emit("notify", "Failed to duplicate panel preset.")
                })
                this.closePresetEditor()
            },
            notify: function(notificationContents, notificationDuration=2500){
				this.notificationContents = notificationContents;
				this.showNotification = true;
				this.notificationDuration = notificationDuration;
			},
        },
        mounted: function () {
            this.$nextTick(function () {
                this.loadPresetData()
                this.fetchCostData()
            })
        }
    }
</script>

<style scoped>
    .md-dialog:not(.vertical-layout){
        max-width: 96vw !important;
        width: 96vw;
        max-height: 100vh !important;
    }
</style>